import { useLocalizedHref } from "@libraries/web-framework";
import { useIntl } from "react-intl";

import { ProductNavBar } from "@/components/wpl/product-navbar/src";

const JiraSoftwareNavPaidLpJswTracker = () => {
    const intl = useIntl();
    return (
        <ProductNavBar
            productHref={useLocalizedHref("/software/jira")}
            productName="jirasoftware"
            freeHref={useLocalizedHref("/software/jira/free")}
            ariaLabel={intl.formatMessage({
                id: "wacJiraSoftwareNavigation.paidLpJswTracker.logo-label",
                defaultMessage: "Jira Software logo"
            })}
            dataProductKey="jiraSoftware"
            showFreeHrefButton={false}
        />
    );
};

JiraSoftwareNavPaidLpJswTracker.displayName = "JiraSoftwareNav";

export default JiraSoftwareNavPaidLpJswTracker;
